import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tabs as FoundationsTabs, Tab as FoundationsTab } from 'foundations-components/transitional/components/Tabs';
import { OPTIMIZATION_TAB, PERFORMACE_TAB, SMART_CONTENT_TAB, TEST_RESULTS_TAB } from '../constants/tabs';
import useSmartContent from '../hooks/useSmartContent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Tabs = ({
  currentTabSelection,
  updateCurrentSelection
}) => {
  const {
    smartContentDefinitionsCount
  } = useSmartContent();
  const shouldShowSmartContentTab = smartContentDefinitionsCount > 0;
  return /*#__PURE__*/_jsxs(FoundationsTabs, {
    defaultSelected: PERFORMACE_TAB,
    selected: currentTabSelection,
    children: [/*#__PURE__*/_jsx(FoundationsTab, {
      tabId: PERFORMACE_TAB,
      "data-test-id": "performance-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.tabs.performance"
      }),
      onClick: () => updateCurrentSelection(PERFORMACE_TAB)
    }), /*#__PURE__*/_jsx(FoundationsTab, {
      tabId: OPTIMIZATION_TAB,
      "data-test-id": "optimization-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.tabs.optimization"
      }),
      onClick: () => updateCurrentSelection(OPTIMIZATION_TAB)
    }), /*#__PURE__*/_jsx(FoundationsTab, {
      tabId: TEST_RESULTS_TAB,
      "data-test-id": "test-results-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.tabs.testResults"
      }),
      onClick: () => updateCurrentSelection(TEST_RESULTS_TAB)
    }), shouldShowSmartContentTab && /*#__PURE__*/_jsx(FoundationsTab, {
      tabId: SMART_CONTENT_TAB,
      "data-test-id": "smart-content-tab",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.tabs.smartContent"
      }),
      onClick: () => updateCurrentSelection(SMART_CONTENT_TAB)
    })]
  });
};
export default Tabs;